import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, db } from '../firebase-config';
import { onAuthStateChanged } from 'firebase/auth';
import { collection, query, where, getDocs } from 'firebase/firestore';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null); // 'admin' ou 'employee'
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      if (user) {
        // Forcer le refresh du token pour récupérer les custom claims
        await user.getIdToken(true);
        // Chercher le rôle dans Firestore
        let role = null;
        try {
          const employeesRef = collection(db, 'employees');
          const q = query(employeesRef, where('email', '==', user.email));
          const querySnapshot = await getDocs(q);
          if (!querySnapshot.empty) {
            const userData = querySnapshot.docs[0].data();
            role = userData.role === 'admin' ? 'admin' : 'employee';
          } else {
            // Si l'utilisateur n'est pas trouvé, on le considère comme salarié
            role = 'employee';
          }
        } catch (e) {
          role = 'employee';
        }
        setUserRole(role);
      } else {
        setUserRole(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, userRole, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
} 